import { FC } from "react";
import { useTranslation } from "react-i18next";

import { MapObject } from "../../../../models/MapObject";
import { useActions } from "../../../../hooks/useActions";
import { useTypedSelector } from "../../../../hooks/useTypedSelector";
import useMobileScreen from "../../../../hooks/useMobileScreen";
import { breakpoints } from "../../../../constants";
import {
  ListViewHeaderCell,
  ListViewHeaderIconSpacer,
  ListViewHeaderRow,
  ListViewStickyHeader,
} from "../../../../share/searchResults";
import MainSearchResultsItem from "./MainSearchResultsItem";
import SearchResultsResponsive from "../../../../share/searchResults/SearchResultsResponsive";

const SearchResults: FC = () => {
  const { mapObjects } = useTypedSelector((state) => state.mapObjectsInfo);
  const { isListViewActive } = useTypedSelector((state) => state.mapInterface);
  const {
    refreshFeedForMainMapSearchResults,
    setCleanAllFilters,
    getDefaultResult,
  } = useActions();
  const isMobile = useMobileScreen(breakpoints.medium);
  const shouldRenderHeader =
    isListViewActive &&
    !isMobile &&
    Boolean(mapObjects?.objects && mapObjects.objects.length > 0);

  const { t } = useTranslation("translation", {
    keyPrefix: "mainPage.mapFilters.listView.headers.aimap",
  });

  const handleClean = () => {
    setCleanAllFilters();
    getDefaultResult();
  };

  return (
    <SearchResultsResponsive
      count={mapObjects.count}
      handleLoadFeed={refreshFeedForMainMapSearchResults}
      onClearAllFilters={handleClean}
    >
      {shouldRenderHeader && (
        <ListViewStickyHeader>
          <ListViewHeaderRow>
            <ListViewHeaderIconSpacer aria-hidden="true" />
            <ListViewHeaderCell flex="2 1 320px">
              {t("object")}
            </ListViewHeaderCell>
            <ListViewHeaderCell flex="1 1 220px">
              {t("constructionType")}
            </ListViewHeaderCell>
            <ListViewHeaderCell flex="1 1 200px">
              {t("class")}
            </ListViewHeaderCell>
          </ListViewHeaderRow>
        </ListViewStickyHeader>
      )}
      {mapObjects?.objects?.map((mapObject: MapObject) => {
        return (
          <MainSearchResultsItem
            key={mapObject.hash_id}
            mapObject={mapObject}
          />
        );
      })}
    </SearchResultsResponsive>
  );
};

export default SearchResults;
